/**
 * Directive: calendar
 */
angular.module('acme.common.directive.calendar', [
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.calendar',
  'acme.common.service.permissions',
  'acme.common.directive.calendarCreateEvent',
  'acme.common.service.userPreferences'
])
.directive('calendar', ['CalendarService', 'PermissionsService', 'UserPreferencesService', 'ApiService', function(CalendarService, PermissionsService, UserPreferencesService, ApiService) {

  var renderTimer,
      date = new Date(),
      d = date.getDate(),
      m = date.getMonth(),
      y = date.getFullYear();

  return {
    restrict: 'A',
    replace: false,
    template: '<div data-calendar-create-event calendarCreateEventId="{{ id }}"></div>',
    scope: {
      id: '@',
      events: '='
    },

    link: function($scope, $element, $attrs) {

      console.log('calendar::link -> "' + $scope.id + '"');
      console.log('calendar -> events: ', $scope.events);

      //if ($element.hasOwnProperty('fullCalendar')) {

        // Used for date sharing with scheduler
        var initialDate = new Date(),
            defaultView = 'month',
            hourFormat = UserPreferencesService.getDateFormat('standardTime', 'hourFormat');

        if ( CalendarService.current.hasOwnProperty('startTimeTracker')) {
            initialDate = CalendarService.current.startTimeTracker;
        }
        if ( CalendarService.current.hasOwnProperty('defaultView') ) {
            defaultView = CalendarService.current.defaultView;
        }
        
        $scope.$on('UserPreferencesService:onDateFormatLoad', onDateFormatLoad);

        loadCalendar();
        clearTimeout(renderTimer);
        renderTimer = setTimeout(function () {
          $element.fullCalendar('gotoDate', initialDate.getFullYear(), initialDate.getMonth(), initialDate.getDate());
          $element.fullCalendar('render');
        });
      //}
      
      function loadCalendar() {
        $element.fullCalendar( 'destroy' );
        $element.fullCalendar({
          editable: false,
          weekMode: 'fixed',
          capWeekHeight: false,
          capDayHeight: false,
          axisFormat: getTimeFormatByKey(),
          firstDay: UserPreferencesService.getStartDayOfWeek(),
          header: {
            left: 'today',
            center: 'prev title next',
            right: 'month,agendaWeek,agendaDay'
          },
          titleFormat: {
            month: checkDateFormat(UserPreferencesService.getDateFormat('month', 'dateFormat')),
            week: checkDateFormat(UserPreferencesService.getDateFormat('week', 'dateFormat')),
            day: checkDateFormat(UserPreferencesService.getDateFormat('day', 'dateFormat'))
          },
          viewRender: $scope.calendar.onViewRender,
          eventClick: $scope.calendar.onEventClick,
          dayClick: $scope.calendar.onDayClick,
          events: $scope.events,
          timeFormat: getTimeFormatByKey(),
          defaultView: defaultView
        });
      }
      function onDateFormatLoad(e, data) {
        loadCalendar();
        $element.fullCalendar('render');
      }
      
       function getTimeFormatByKey () {
        var hash = {
          'HH:mm' : 'HH:mm',
          'default': 'h:mm tt'
        };
        return hash[hourFormat] || hash['default'];
      }
      
      function checkDateFormat(date) {
        return (date.indexOf('EEEE') !== -1) ? date.replace(/EEEE/, 'dddd') : date;
      }

    },

    controller: ['$scope', '$state', '$uibModal', '$element', 'CalendarService', function($scope, $state, $uibModal, $element, CalendarService) {
      var date = new Date();
      var d = date.getDate();
      var m = date.getMonth();
      var y = date.getFullYear();
      $scope.calendar = {

        model: {
          events: []
        },

        init: function() {

          $scope.$on('calendarCreateEvent::edit', this.onOnCalendarCreateEdit);
          $scope.$on('calendarCreateEvent::view', this.onOnCalendarCreateView);
          $scope.$on('calendarCreateEvent::cancel', this.onOnCalendarCreateCancel);
          $scope.$on('calendarCreateEvent::complete', this.onOnCalendarCreateComplete);
          $scope.$on('calendarCreateEvent::events', this.onOnCalendarCreateEvents);
          $scope.$on('calendarCreateEvent::update', this.onOnCalendarCreateUpdate);
          $scope.$on('calendarCreateEvent::todayClick', this.onOnCalendarCreateTodayClick);
          $scope.$on('$destroy', function() {
            $element.fullCalendar( 'destroy' );
          });

        },

        // Prune temporary events
        prune: function() {

          var i, ii;

          if ($scope.events instanceof Array) {
            for (i=0,ii=$scope.events.length;i<ii;i++) {
              if ($scope.events[i].color === 'lightblue') {
                $scope.events.splice(i, 1);
              }
            }
          }

        },

        onEventClick: function(calEvent, jsEvent, view) {
          ApiService.event.detail(calEvent.id).then(function(response) {
            
            calEvent.requestSummary = angular.extend({}, response.data.payload.eventResourceSummary);
            
            console.log('calendar['+$scope.id+']::onEventClick', arguments);
            $scope.$emit('calendar['+$scope.id+']::onEventClick', {
              calEvent: calEvent,
              event: jsEvent,
              view: view
            });
            $scope.$broadcast('calendar::onEventClick', {
              calEvent: calEvent,
              event: jsEvent,
              view: view
            });
          });


        },

        onOnCalendarCreateTodayClick: function(e, data) {
          $scope.$emit('calendar['+$scope.id+']::onTodayClick');
        },

        onOnCalendarCreateEdit: function(e, data) {
          $state.go('application.templates.edit.description', { id: data.model.id });
        },

        onOnCalendarCreateView: function(e, data) {
          $state.go('application.programsInstance', { id: data.model.id });
        },

        onOnCalendarCreateComplete: function(e, data) {
          CalendarService.create(data);
          $state.go('application.templates.create.description');
        },

        onOnCalendarCreateEvents: function(e, data) {
          //$scope.$apply();
          $element.fullCalendar('refetchEvents');
          console.log('onOnCalendarCreateEvents', $scope.events);
          //$scope.events = data.events;
        },

        onOnCalendarCreateCancel: function() {
          $scope.calendar.prune();
          $element.fullCalendar('refetchEvents');
        },

        onOnCalendarCreateUpdate: function(e, data) {
          $element.fullCalendar('gotoDate', data.date.getFullYear(), data.date.getMonth(), data.date.getDate());
          $element.fullCalendar('render');
        },

        onDayClick: function(date, jsEvent, view) {

          if (PermissionsService.check('EVENT_TEMPLATE_CREATE')) {
            $scope.calendar.prune();

            date.setHours(12);

            $scope.events.push({
              color: 'lightblue',
              title: '',
              start: date,
              allDay: false
            });

            $scope.$emit('calendar[' + $scope.id + ']::onDayClick', {
              date: date,
              event: jsEvent,
              view: view
            });

            $scope.$broadcast('calendar::onDayClick', {
              date: date,
              event: jsEvent,
              view: view
            });

            $element.fullCalendar('refetchEvents');
          }
        },

        onViewRender: function(view, element) {
          $scope.$emit('calendar['+$scope.id+']::onViewRender', {
              view: view,
              element: element
          });

          $scope.$broadcast('calendar::onViewRender', {
              view: view,
              element: element
          });
        }

      };

      $scope.calendar.init();

    }]

  };

}]);